import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import cx from 'classnames';

import AddMinusButton from 'components/shared/AddMinusButton';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import { IAccordionSpoiler } from 'detailsv2/__blocks';

import { useBlockContext } from '../../Block/context';
import { useAccordion } from './functions';
import styles from './index.module.css';
import Spoiler from './Spoiler';

function Accordion() {
  const {
    readonly,
    index: blockIndex,
    onAddBlockInsideSpoiler,
    onDeleteBlockInsideSpoiler,
    onUpdateBlockInsideSpoiler,
  } = useBlockContext();

  const {
    spoilers,
    activeItem,
    handleToggleSpoiler,
    handleDeleteSpoiler,
    handleChangeSpoiler,
    handleAddSpoiler,
    setActiveItem,
    sensors,
    handleDragEnd,
    spoilersDndIds,
  } = useAccordion();

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={spoilersDndIds} strategy={verticalListSortingStrategy}>
        <div className={cx(styles.items, 'custom-accordion')}>
          {spoilersDndIds.map((id, spoilerIndex) => {
            const indexes = { blockIndex, spoilerIndex };

            const onAddBlock = onAddBlockInsideSpoiler?.(indexes);
            const onUpdateBlock = onUpdateBlockInsideSpoiler?.(indexes);
            const onDeleteBlock = onDeleteBlockInsideSpoiler?.(indexes);

            return (
              <Spoiler
                key={id}
                id={id}
                isActive={id === activeItem}
                onToggle={() => handleToggleSpoiler(activeItem, id)}
                onDelete={() => handleDeleteSpoiler(id)}
                data={spoilers[id]}
                onChange={(data: IAccordionSpoiler) => handleChangeSpoiler(id, data)}
                readOnly={readonly}
                setActiveItem={setActiveItem}
                onAddBlock={onAddBlock}
                onUpdateBlock={onUpdateBlock}
                onDeleteBlock={onDeleteBlock}
              />
            );
          })}
        </div>
      </SortableContext>

      {!readonly && (
        <FormActions isCenter>
          <AddMinusButton onClick={() => handleAddSpoiler()} />
        </FormActions>
      )}
    </DndContext>
  );
}

export default Accordion;
